import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/svg/menu/vti.svg'
import _imports_1 from '@/assets/svg/close.svg'
import _imports_2 from '@/assets/svg/menu/telephone.svg'
import _imports_3 from '@/assets/svg/menu/email.svg'
import _imports_4 from '@/assets/svg/menu/location.svg'
import _imports_5 from '@/assets/svg/menu/lk.svg'
import _imports_6 from '@/assets/svg/menu/tg.svg'
import _imports_7 from '@/assets/svg/menu/vk.svg'


const _hoisted_1 = {
  key: 0,
  class: "navigation-wrapper"
}
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { class: "px-3 py-4" }
const _hoisted_4 = { class: "d-flex justify-content-between w-100 mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"160px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-two-gradient" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3 mt-4",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "navigation-icon mx-2",
    src: _imports_2
  }),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navigation-text-info",
    href: "tel:+74712400770"
  }, "8 (4712) 400-770 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center my-3",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "navigation-icon mx-2",
    src: _imports_3
  }),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navigation-text-info",
    href: "mailto:info@vti-service.ru"
  }, "info@vti-service.ru")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "navigation-icon mx-2",
    src: _imports_4
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-start" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "navigation-text-info",
      href: "https://yandex.ru/maps/org/vti_servis/1210119352/?ll=36.187930%2C51.739176&z=17.89",
      target: "_blank"
    }, "г. Курск, ул. Ватутина, д. 25"),
    /*#__PURE__*/_createElementVNode("div", { class: "navigation-text-info" }, "с 9-00 до 18-00 ")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "navigation-icon mx-2",
  src: _imports_5
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { class: "navigation-text-info" }, "Перейти в личный кабинет ", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://t.me/vtiservicekursk",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "navigation-icon mx-2 icon mx-2",
      src: _imports_6
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://vk.com/vti.service",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "navigation-icon mx-2",
      src: _imports_7
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("img", {
                    src: _imports_1,
                    role: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                  })
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.scroll('home'); _ctx.$emit('update:modelValue', false)})
                  }, "Главная"),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.scroll('benefits'); _ctx.$emit('update:modelValue', false)})
                  }, "Наши преимущества"),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.scroll('kassa'); _ctx.$emit('update:modelValue', false)})
                  }, "VDCloud"),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.scroll('payment'); _ctx.$emit('update:modelValue', false)})
                  }, "Процесс оплаты "),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.scroll('niches'); _ctx.$emit('update:modelValue', false)})
                  }, "Кому подходит"),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.scroll('join'); _ctx.$emit('update:modelValue', false)})
                  }, "Процесс подключения"),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.scroll('integration'); _ctx.$emit('update:modelValue', false)})
                  }, "Интеграция кассы"),
                  _createElementVNode("li", {
                    class: "navigation-text",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.scroll('testing'); _ctx.$emit('update:modelValue', false)})
                  }, "Тестирование")
                ]),
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("div", {
                  class: "d-flex my-3",
                  role: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openLK && _ctx.openLK(...args)))
                }, _hoisted_12),
                _hoisted_13
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}